import { THEME_NAMES } from 'themes';
import { useThemeName } from './use-theme';

export function useTwyford(): boolean {
  const theme = useThemeName();
  return theme === THEME_NAMES.TWYFORD;
}
